var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.9999L1.33333 15.7249L2.66667 16.9999L4 15.7249L5.33333 16.9999L6.66667 15.7249L8 16.9999L9.33333 15.7249L10.6667 16.9999L12 15.7249L13.3333 16.9999L14.6667 15.7249L16 16.9999V-6.10352e-05L14.6667 1.27494L13.3333 -6.10352e-05L12 1.27494L10.6667 -6.10352e-05L9.33333 1.27494L8 -6.10352e-05L6.66667 1.27494L5.33333 -6.10352e-05L4 1.27494L2.66667 -6.10352e-05L1.33333 1.27494L0 -6.10352e-05M13.3333 5.94994H2.66667V4.24994H13.3333M13.3333 9.34994H2.66667V7.64994H13.3333M13.3333 12.7499H2.66667V11.0499H13.3333V12.7499Z",
    fill: "#2E8056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateInvoice);
export default __webpack_public_path__ + "static/media/generateInvoice.72213dbe51de0368871743330bfa2f96.svg";
export { ForwardRef as ReactComponent };